// extracted by mini-css-extract-plugin
module.exports = {"container":"RichText_container__Xj5P6","sans":"RichText_sans__YJzFj","smallSans":"RichText_smallSans__1hXKf"};